import { render, staticRenderFns } from "./m-new-media-viewer.vue?vue&type=template&id=7c5f3a69&scoped=true"
import script from "./m-new-media-viewer.vue?vue&type=script&lang=js"
export * from "./m-new-media-viewer.vue?vue&type=script&lang=js"
import style0 from "./m-new-media-viewer.vue?vue&type=style&index=0&id=7c5f3a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f3a69",
  null
  
)

export default component.exports